// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"centimeter"},"nodeName":"g","children":[{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M9 19H3C2.44772 19 2 18.5523 2 18V6C2 5.44772 2.44772 5 3 5H9","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M22 19V6C22 5.44772 21.5523 5 21 5L17 5M17 5L17 19M17 5L12 5L12 19","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-centimeter')
export default class CentimeterIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'centimeter',
    }
  }
}
